import script from "./RoleRequiredCalendarCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredCalendarCell.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredCalendarCell.vue?vue&type=style&index=0&id=8b0d3364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0d3364"]])

export default __exports__